import { Component, OnInit, AfterContentInit, ViewChild, OnDestroy, QueryList, ViewChildren, ElementRef, Renderer2,HostListener,Input} from '@angular/core';
import { Router, Event, NavigationEnd, NavigationError, NavigationStart } from '@angular/router';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { environment } from './../../../environments/environment';
import { LogoutUser, AuthUserData, DarkModeAction, UserBalanceData, DARK_MODE } from './../../store/actions/appActions';
import { MainService } from './../../_services/main.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective, PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { AddfundPopupComponent } from 'src/app/addfund-popup/addfund-popup.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { ResultboardService } from 'src/app/resultboard/resultboard.service';
import { CountdownComponent } from 'ngx-countdown';
import { LeagueInviteComponent } from '../league-invite/league-invite.component';
import { AuthenticationService } from 'src/app/_services';
import { AddMessageComponent } from 'src/app/add-message/add-message.component';
import { ChatAdapterHistory } from 'src/app/_services/chat-adapter';
import { FaqComponent } from './../../faq/faq.component';
import { MatMenuTrigger } from '@angular/material';
import { GamepreviewpopupComponent } from 'src/app/gamepreviewpopup/gamepreviewpopup.component';
import { element } from '@angular/core/src/render3/instructions';
import moment from 'moment-timezone';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: []
})

export class HeaderComponent implements OnInit, OnDestroy, AfterContentInit {

  @ViewChildren(CountdownComponent) activeCounter: QueryList<CountdownComponent>;

  adSpacer = false;
  site_title = 'Drafters';
  users: any;
  tournamentURL: string;
  errors: string;
  user_name: string;
  userLogin: any;
  currentUser: any;
  user_id: number;
  drafters_id: string;
  my_team_data: any;
  assetURL: string;
  awsUploadUrl: string;
  draftStatus: string;
  scrollOffset: number;
  cursor: number;
  heightScrollTeam: number;
  stopScroll: boolean;
  siteURL: string;
  isMobile = false;
  subActiveDraft: Subscription;
  sub_active_draft_data: Subscription;
  subactivePickChanges: Subscription;
  subChangeInCurrentDraft: Subscription;
  sub_pick_changes: Subscription;
  subrestart_msg: Subscription;
  subNotificationsReq: Subscription;
  subNotificationsData: Subscription;
  sub_displayMessages: Subscription;
  sub_receiveMessage: Subscription;
  sub_userData: Subscription;
  sub_isMobileScreen: Subscription;
  sub_balanceData: Subscription;
  sub_league_draft: Subscription;
  sub_currentlyWinning: Subscription;
  activeDraft: any = [];
  notificationData: any = [];
  league_type: string;
  draftID: string;
  is_tournament: string;
  notiCursor = 0;
  myTeamChecked = 'drafting';
  props_launch_flag = '';
  msgCursor = 1;
  messages = [];
  endMsg = true;
  notifiCounter = 0;
  msgCounter = 0;
  pRCounter = 0;
  friend_request = [];
  userInfo: any;
  inviteDialogRef: MatDialogRef<LeagueInviteComponent>;
  addMessageDialogRef: MatDialogRef<AddMessageComponent>;
  leagueRecord: any;
  isMenuVisible: boolean;
  darkMode= false;
  sub_darkMode:Subscription;
  val: string = '🐘';
  title = 'app works!';
  showHeader : boolean = true;
  public config: PerfectScrollbarConfigInterface = {
    wheelPropagation: false,
    wheelSpeed: 0.15
  };

  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('menu') menu: ElementRef;


  
  winAmt: any;
  pageName: any = null;
  stickyheader = false;
  gamePreviewDialogRef: MatDialogRef<GamepreviewpopupComponent>
  @HostListener("window:scroll", [])
  onWindowScroll() { 
    if (window.scrollY > 80) {
      this.stickyheader =true;
    }else{
      this.stickyheader = false;
    }
  }
  
  @Input() showSmartBanner: boolean;

  constructor(private store: Store<AppState>,
    private router: Router,
    private _appService: MainService,
    public dialog: MatDialog,
    private deviceService: DeviceDetectorService,
    private _location: Location,
    private _resultBoardService: ResultboardService,
    private authenticationService: AuthenticationService,
    private renderer: Renderer2
    // private chatdapter: ChatAdapterHistory
  ) {
    this.isMobile = this.deviceService.isMobile();
    this.sub_darkMode =  this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
      }
    });
    this.sub_balanceData = this.store.select('userBalance').subscribe(state => {
      if (state.length > 0 && this.userInfo) {
        this.userInfo.dollar_balance = state[0];
      }
    });
    let dm = localStorage.getItem('darkMode');
    if(dm=='true' || dm==null){
      this.darkMode = false;
      this.toggleDarkTheme();
    }
    this.pageName = this.router.url.split('/');//this.router.url.split('/')['2']; 
    // this.pageName = this.pageName[this.pageName.length - 1];
    if (this.sub_isMobileScreen) { this.sub_isMobileScreen.unsubscribe(); }
    this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
        if (this.isMobile) {
          setTimeout(() => {
            this.showDraftStatus();
            this.activeDrafts(1);
            this.activePickChanges();
            // this.pick_changes(); 
            this.restart_msg();
            // this.subChangeInCurrentDraft =  this.store.select('changeInCurrentDraft').subscribe(state => { 
            //   if(state){ 
            //     this.activeDrafts(0); 
            //   }
            // });
          }, 1000);
        }
      }
    });
    //this.isMobile = this.deviceService.isMobile();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.user_id = this.currentUser.id;
      this.user_name = this.currentUser.username;
      this.drafters_id = this.currentUser.drafters_id;
    }

    router.events.subscribe((event: Event) => {

      if (event instanceof NavigationStart) {
        // Show loading indicator
        this.isMenuVisible = false;
      }

      if (event instanceof NavigationEnd) {
        this.pageName = this.router.url.split('/');
        this.league_type = this.router.url.split('/')['4'];
        this.draftID = this.router.url.split('/')['5'];
        this.is_tournament = this.router.url.split('/')['6'];
        this.isHeaderShow();
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator
      }
    });
    
    this.renderer.listen('window', 'click',(evt)=>{
      /**
       * Only run when toggleButton is not clicked
       * If we don't check this, all clicks (even on the toggle button) gets into this
       * section which in the result we might never see the menu open!
       * And the menu itself is checked here, and it's where we check just outside of
       * the menu and button the condition abbove must close the menu
       */
       
        if (typeof this.toggleButton !== 'undefined' && typeof this.menu !== 'undefined') {
          if(!this.toggleButton.nativeElement.contains(evt.target) && !this.menu.nativeElement.contains(evt.target)) {
              this.isMenuVisible=false;
          }
        }
    });
   
  }
  
  isHeaderShow(){
    const  urlArr =this.pageName;
    this.showHeader = !urlArr.join('/').includes('/register/welcome');
    console.log(this.showHeader )
  }

  toggleMenu() {
    this.isMenuVisible = !this.isMenuVisible;
  }

  emojiAdded(v) {
    this.val = v;
  }

  openDialog(tab) {
    this.dialog.closeAll();
    const dialogRef =  this.dialog.open(AddfundPopupComponent, {
      width: '850px',
      data: { 'tab': tab}
    });
    // dialogRef.componentInstance.onFundAdd.subscribe((data) => {
    //   // do something
    //   this.userInfo.dollar_balance = parseFloat(this.userInfo.dollar_balance) + parseFloat(data.fund_added);
    // });
  }

  ngOnInit() {
    if (this.user_id) {
      this.callInitData();
    }
    this.league_type = this.router.url.split('/')['4'];
    this.draftID = this.router.url.split('/')['5'];
    this.is_tournament = this.router.url.split('/')['6'];
    this.store.select('user').subscribe(state => {
      if (state[0]) {
        this.users = state[0];
        this.user_id = state[0]['user_id'];
        this.user_name = state[0]['user_name'];
        this.drafters_id = state[0]['drafters_id'];
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.callInitData();
      }
    });
    this.assetURL = `${environment.assetURL}`;
    this.awsUploadUrl = `${environment.assetUploadURL}`;
    this.scrollOffset = 320;
    this.cursor = 0;
    this.stopScroll = true;
    this.tournamentURL = `${environment.tournament}`;
    this.siteURL = `${environment.SITE_URL}`;
    this.isMenuVisible = false;
    if (this.isMobile && this.user_id) {
      /* this.activeDrafts(); 
      this.showDraftStatus();  
      this.activePickChanges(); 
      this.pick_changes(); 
      this.restart_msg();

      this.subChangeInCurrentDraft =  this.store.select('changeInCurrentDraft').subscribe(state => { 
        if(state){ 
          this.activeDrafts(); 
        }
      });  */
    }
    this.displayMessages();
    if (this.pageName.indexOf('messages') == -1) {
      this.receiveMessages();  
    }
    else {
      this.receiveMessagesListner();
    }
    
    this.getLeagueRecord();
    // if(this.user_id){
    //   this.headerNotification();
    //   this.friendInviteNoti();
    //   this.friendMsgInviteNoti();
    //   this.displyNotifications();
    // }
    this.isHeaderShow();
  }

  getLeagueRecord() {
    // this.sub_league_draft = this.store.select('league_draft').subscribe(state => {
    //   if (state.length > 0) {
    //     this.leagueRecord = state[0];
    //   }
    // });
  }

  callInitData() {
    if (this.isMobile) {
      setTimeout(() => {
        this.showDraftStatus();
        this.activeDrafts(0);
        this.activePickChanges();
        // this.pick_changes(); 
        this.headerNotification();
        this.friendInviteNoti();
        this.friendMsgInviteNoti();
        this.restart_msg();
        this.getUserDetails();
        this.getCurrentlyWinning();
        this.displyNotifications();
        // this.subChangeInCurrentDraft =  this.store.select('changeInCurrentDraft').subscribe(state => { 
        //   if(state){ 
        //     this.activeDrafts(0); 
        //   }
        // }); 
      }, 1000);
    } else {
      this.showDraftStatus();
      this.activeDrafts(0);
      this.activePickChanges();
      this.pick_changes();
      this.restart_msg();
      this.headerNotification();
      this.friendInviteNoti();
      this.friendMsgInviteNoti();
      this.displyNotifications();
      this.getUserDetails();
      this.getCurrentlyWinning();
    }
  }

  onLogout() {
    this.authenticationService.logout();
    this.store.dispatch(new LogoutUser(1));
    window.location.href = `${environment.SITE_URL}` + '/logout';
    //this.router.navigate(['/login']);
  }

  ngAfterContentInit() {
    //this.myTeamFilter('drafting', 0);
  }

  onScrollEvent(ev) {
    if (this.componentRef.directiveRef.geometry().y > (this.componentRef.directiveRef.geometry().h - this.scrollOffset) && this.stopScroll === true) {
      this.myTeamFilter(this.draftStatus, 1);
    }
  }

  myTeamFilter(filter, init) {
    this.myTeamChecked = filter;
    if (Number(init) === 0) {
      this.cursor = 0;
      this.my_team_data = [];
      this.stopScroll = true;
    }
    this._appService.getTeam(this.user_id, filter, this.cursor)
      .subscribe(shows => {
        this.draftStatus = filter;
        if (shows.status === 'success' && shows.entities.length > 0) {
          this.my_team_data = this.my_team_data.concat(shows.entities);
          this.cursor++;
        } else {
          this.stopScroll = false;
        }
      }, err => {
        console.log(err);
        this.errors = <any>err;
      });
  }

  myTeamPage() {
    window.location.href = this.siteURL + "/scores";
  }

  backClicked() {
    this._location.back();
  }

  activeDrafts(is_connect) {
    // if( this.subActiveDraft ) { this.subActiveDraft.unsubscribe(); }
    // if(this.user_id){
    //   this.subActiveDraft = this._resultBoardService.activeDraftEmit({user_id:this.user_id,is_app:'',is_connect:is_connect}).subscribe();
    // }
  }

  showDraftStatus() {
    // this.sub_active_draft_data = this._resultBoardService.showActiveDraftData().subscribe(state => { 
    //   if (state.length > 0) {   
    //     const mobileDraft = [];
    //     let localDraftKey = [];
    //     const state_loop = state;  
    //     state_loop.forEach((element, key) => {
    //       if(element.draft_start !== 2){
    //         let is_push = true;
    //         let record = {'text':'starts in','buy_in_amount':element.buy_in_amount,'league_name':element.league_name,'league_id':element.league_id,'league_type':element.league_type,'league_code':element.league_code,'timer':0,'url':'/draft/' + element.league_id,status:element.status}; 
    //         if (element.is_paused === 'N') {
    //           if (element.draft_start === 1) {
    //             if (element.pick_status === 0) {
    //               record.text = ''; 
    //               let mob_pick = '1 away!';
    //               if (element.remaining_time > 1) {  
    //                 mob_pick = element.remaining_time + ' away!'; 
    //               } 
    //               record.text = mob_pick;
    //             } else {
    //               record.text = 'Pick!';
    //               record.timer = element.remaining_time; 
    //             }
    //           } else if (element.draft_start === 0) { 
    //             if (element.joined_entrants < element.entrants) {
    //               record.text = 'Registering';  
    //             } else {
    //               record.timer = element.remaining_time;  
    //             }
    //           } else { 
    //             is_push = false;
    //           } 
    //         } else {
    //           record.text = 'Paused!'; 
    //         } 
    //         if(is_push) {
    //           localDraftKey.push(element.league_code);
    //           mobileDraft.push(record);
    //         }
    //       }
    //     }); 
    //     this.activeDraft  = mobileDraft.map(x=>Object.assign({},x)); 
    //     this.removeExtraKeyLocally(localDraftKey);
    //     //this.resetTimer();
    //   }else{
    //     localStorage.removeItem('game_keys');
    //     localStorage.removeItem('player_data');
    //     this.activeDraft  = [];
    //   }
    // });
  }

  // remove player table data from local stroge if league is drafted
  removeExtraKeyLocally(pArr) {
    let game_keys = JSON.parse(localStorage.getItem('game_keys'));
    if (game_keys != null) {
      game_keys.forEach(element => {
        if (pArr.indexOf(element) == -1) {
          game_keys.splice(pArr.indexOf(element), 1);
          localStorage.setItem('game_keys', JSON.stringify(game_keys));
          let plyData = JSON.parse(localStorage.getItem('player_data'));
          if (plyData != null) {
            let index = plyData.findIndex(x => x.key == element);
            if (index > -1) {
              plyData.splice(index, 1);
              localStorage.setItem('player_data', JSON.stringify(plyData));
            }
          }
        }
      });
    }
  }

  activePickChanges() {
    // this.subactivePickChanges = this._resultBoardService.activePickChanges().subscribe(data => {
    //   if (data) {     
    //     this.activeDrafts(0); 
    //   }
    // });
  }

  getCurrentlyWinning() {
    if (this.currentUser) {
      this.sub_currentlyWinning = this._appService.getCurrentlyWinning(this.user_id).subscribe((res: any) => {
        if (res) {
          this.winAmt = res.currently_winning;
        }
      });
    }
  }

  toggleDarkTheme(): void {
   this.darkMode = !this.darkMode;
    this.store.dispatch(new DarkModeAction({'isDarkMode':this.darkMode}));
    document.body.classList.toggle('dark-theme');
    localStorage.setItem('darkMode',this.darkMode?'true':'false');
 }
  pick_changes() {
    // this.sub_pick_changes = this._resultBoardService.activeDraftPickChanges().subscribe(state => {
    //   if (state) {
    //     if(this.activeDraft) { 
    //       let restartTimer = 0;
    //       let callActiveDraft = 0;
    //       let current_picking = 0;
    //       let eleData;
    //       this.activeDraft.forEach((element,key) => {
    //         if (Number(element.league_id) === Number(state.entities.league.id)) {
    //           if (Number(state.entities.pick_info_box.status) === 3) {
    //             if (Number(state.entities.pick_info_box.is_active) === 0) {
    //               let mob_pick = state.entities.active_draft.msg;
    //               this.activeDraft[key]['text'] = mob_pick;
    //               this.activeDraft[key]['timer'] = 0;
    //               this.activeDraft[key]['status'] = 3; 
    //               this.resetTimer(key,'pause');
    //             }else{
    //               this.activeDraft[key]['status'] = 2;
    //               if(typeof state.entities.active_draft.is_paused !=="undefined" && state.entities.active_draft.is_paused==1){
    //                 this.activeDraft[key]['timer'] = 0;
    //                 this.activeDraft[key]['text'] = 'Paused!';
    //                 this.resetTimer(key,'pause');
    //               } else {
    //                 this.activeDraft[key]['timer'] = state.entities.active_draft.time_left; 
    //                 this.activeDraft[key]['text'] = 'Pick!';
    //                 this.resetTimer(key,'restart');
    //               }
    //               restartTimer  = 1;
    //             }
    //           }else if (state.entities.pick_info_box.status === 2) {
    //             this.activeDraft[key]['text'] = 'starts in';
    //             this.activeDraft[key]['status'] = 1;
    //             this.activeDraft[key]['timer'] = state.entities.active_draft.time_left;
    //           // }else if (Number(state.draft_status) === 3) {
    //           //   this.activeDraft.splice(key, 1); 
    //           }else{
    //             this.activeDraft[key]['text'] = 'Complete'; 
    //             this.activeDraft[key]['status'] = 4; 
    //             this.activeDraft[key]['timer'] = 0;
    //             this.resetTimer(key,'pause');
    //             callActiveDraft = 1;
    //           }
    //         }  

    //         // for autoswitch drafting
    //         // if(this.activeDraft[key]['status'] == 2 && (typeof eleData == "undefined" || (eleData && eleData.timer > this.activeDraft[key]['timer']))){
    //         //   eleData = this.activeDraft[key];
    //         // }
    //         // if(this.leagueRecord && (element.league_code == this.leagueRecord.league_code) && this.activeDraft[key]['status'] != 2 && this.activeDraft[key]['status'] != 1 && current_picking == 0) {
    //         //   current_picking =1;
    //         // }
    //       });


    //       this.sortActiveDraft();
    //       if(Number(callActiveDraft) === 1){ 
    //         setTimeout(() => { 
    //         this.activeDrafts(0);
    //         }, 60000);
    //       }
    //       /*
    //       // autoswitch
    //       if(current_picking == 1 && eleData){ 
    //         setTimeout(() => {  
    //           this.router.navigate([`/resultboard/draft/players/`+eleData.league_type+`/`+eleData.league_code]);
    //         }, 2000);
    //       } */
    //     } 
    //   }
    // });
  }

  // sort active draft by picking
  sortActiveDraft() {
    this.activeDraft.sort(function (a, b) {
      if (a.status != b.status) {
        return a.status < b.status ? -1 : 1;
      } else {
        return parseInt(a.timer) - parseInt(b.timer)
      }
    });
  }

  resetTimer(key, type) {
    this.activeCounter.forEach((element, tk) => {
      if (tk == key) {
        if (type == 'pause') {
          element.stop();
        } else if (type == 'restart') {
          element.restart();
        }
      }
    });
  }

  restart_msg() {
    // this.subrestart_msg = this._resultBoardService.restart_msg()
    //   .subscribe(reponse => { 
    //     if (typeof reponse !== 'undefined') { 
    //       if(this.activeDraft) { 
    //         this.activeDrafts(0);
    //       }
    //     }
    //   });
  }

  getNotification() {
    if (this.user_id) {
      this._resultBoardService.getNotification(this.user_id, this.notiCursor).subscribe();
    }
  }

  displyNotifications() {
    this.subNotificationsData = this._resultBoardService.displyNotifications().subscribe(res => {
      this.notifiCounter = 0;
      if (res) {
        let notiData = res.entities;

        notiData.forEach(element => {
          var link = '#';
          var type = (typeof (element.type) !== 'undefined') ? element.type : '';
          var slug = (typeof (element.slug) !== 'undefined') ? element.slug : '';

          if ((type === 'user_follow' || type === 'accept_request' || type === 'unfriend') && typeof (element.username) !== 'undefined' && element.username != '') {
            link = `${environment.SITE_URL}` + '/' + element.username + '/profile';
          } else if (type == 'delete_league') {
            link = 'javascript:;';
          } else if ((type === 'post_like_dislike' || type === 'post_comment') && typeof (element.slug) !== 'undefined' && element.slug !== '') {
            link = `${environment.SITE_URL}` + '/user-post-detail/' + slug;
          } else if (type === 'signup_complete' && element.myusername !== '') {
            link = `${environment.SITE_URL}` + '/setting';
          } else if (element.uri !== '' && element.uri !== null) {
            link = `${environment.SITE_URL}` + '/' + element.uri;
          } else {
            link = 'javascript:;';
          }

          element.link = link;
          element.user_picture = `${environment.assetURL}` + '/assets/uploads/users/' + element.user_id + '/profile/image_50x50/' + element.user_picture;

          this.imageExists(element.user_picture, function (exists) {
            if (!exists) {
              element.user_picture = `${environment.assetURL}` + '/assets/default/images/user.png';
            }
          });
          element.message = this.unescapeString(element.message);
        });
        
        this.notificationData = this.notificationData.concat(notiData);
        this.notiCursor++;
      }
    });
  }

  imageExists(url, callback) {
    var img = new Image();
    img.onload = function () { callback(true); };
    img.onerror = function () { callback(false); };
    img.src = url;
  }

  getMessages() {
    if (this.endMsg) {
      this._resultBoardService.getMessagesEmit(this.user_id, this.msgCursor, 'dropdown');
    }
  }

  displayMessages() {
    this.sub_displayMessages = this._resultBoardService.displayMessages().subscribe((res) => {
      this.msgCounter = 0;
      if (res.entities && res.entities.length > 0) {
        if (this.msgCursor === 1) {
          this.messages = res.entities;
          this.endMsg = false;
        } else {
          this.messages = this.messages.concat(res.entities);
        }
        this.msgCursor++;
      } else {
        this.endMsg = false;
      }
    });
  }

  receiveMessages() {
    this.sub_receiveMessage = this._resultBoardService.newMessage().subscribe((res) => {
      if (res) {
        let isFriend = 0;
        let lastMessage = (!res['message'] && res['media_type']) ? 'Share '+ res['media_type'] : res['message'];
        let created = moment().unix(res['msgTime']) * 1000;
        if (this.messages) {
          this.messages.forEach(element => {
            if (element.friend_id === res['sender_id']) {
              element.chat_message = lastMessage;
              element.created = created;
              isFriend = 1;
            }
          });
        }
        if (isFriend === 0) {
          const newMsg = {'chat_message': lastMessage, 'created': created, 'drafters_id': res['friend_name'], 'friend_id': res['sender_id'], 'picture': res['friend_picture'], 'unread_msg_count': res['unread_chat_count'], 'user_id': res['receiver_id'], 'username': res['friend_username']};
          this.messages = this.messages.concat(newMsg);
          this.msgCounter++;
        }
        this.messages.sort(function (a, b) { return b.created - a.created });
        this._appService.playSound();
      }
    });
  }
  
  receiveMessagesListner() {
    this.sub_receiveMessage = this._resultBoardService.newMsgReceive.subscribe((res) => {
      if (res) {
        let isFriend = 0;
        let lastMessage = (!res['message'] && res['media_type']) ? 'Share '+ res['media_type'] : res['message'];
        let created = moment().unix(res['msgTime']) * 1000;
        if (this.messages) {
          this.messages.forEach(element => {
            if (element.friend_id === res['sender_id']) {
              element.chat_message = lastMessage;
              element.created = created;
              isFriend = 1;
            }
          });
        }
        if (isFriend === 0) {
          const newMsg = {'chat_message': lastMessage, 'created': created, 'drafters_id': res['friend_name'], 'friend_id': res['sender_id'], 'picture': res['friend_picture'], 'unread_msg_count': res['unread_chat_count'], 'user_id': res['receiver_id'], 'username': res['friend_username']};
          this.messages = this.messages.concat(newMsg);
          this.msgCounter++;
        }
        this.messages.sort(function (a, b) { return b.created - a.created });
        this._appService.playSound();
      }
    });
  }
  

  headerNotification() {
    this._appService.headerNotification(this.user_id)
      .subscribe(res => {
        this.notifiCounter = 0;
        if (res.status === 'success') {
          this.notifiCounter = Number(res.entities.notification);
          this.msgCounter = res.entities.messages.length;
          if (res.entities.friend_request.request) {
            res.entities.friend_request.request.forEach(element => {
              element.picture = this._appService.getPicture(element.picture, 'users', element.friend_id);
            });
            this.friend_request = res.entities.friend_request.request;
          }
        }
      }, err => {
        this.errors = <any>err;
      });
  }

  friendMsgInviteNoti() {
    this.sub_receiveMessage = this._resultBoardService.friendMsgInviteNoti().subscribe((res) => {
      if (res) {
        const friend_request = { 'picture': res.user_image, 'drafters_id': res.user_username, 'friend_id': res.user_uuid, 'type': 'friends' };
        this.friend_request.splice(0, 0, friend_request);
        this.friend_request = this.friend_request.concat(friend_request);
      }
    });
  }

  friendInviteNoti() {
    this.sub_receiveMessage = this._resultBoardService.friendInviteNoti().subscribe((res) => {
      if (res) {
        const friend_request = { 'picture': res.user_image, 'drafters_id': res.display_name, 'league_name': res.value.name, 'type': 'invitation', 'abbr': res.value.abbr, 'league_code': res.value.league_code };
        this.friend_request.splice(0, 0, friend_request);
        this.friend_request = this.friend_request.concat(friend_request);
      }
    });
  }

  acceptFriendRequest(request_uuid, index, item) {
    this.friend_request.splice(index, 1);
    this._appService.acceptFriendRequest(request_uuid, this.user_id).subscribe((res) => {
      if (res && res.success) {
        if (this.pRCounter > 0) {
          this.pRCounter--;
          if (this.pRCounter > 0) {
            this._resultBoardService.updateReqCount(this.user_id, this.pRCounter);
          }
        }

        var activeUserData = { 'friend_id': item.friend_id, 'userID': this.user_id, 'user_frnd_img': item.picture, 'user_frnd_name': item.drafters_id, 'user_frnd_uname': item.username };
        this._resultBoardService.addActiveUser(activeUserData);
      }
    });
  }

  rejectFriendRequest(request_uuid, index) {
    this.friend_request.splice(index, 1);
    this._appService.rejectFriendRequest(request_uuid, this.user_id).subscribe((res) => {
      if (res && res.success) {
        if (this.pRCounter > 0) {
          this.pRCounter--;
          if (this.pRCounter > 0) {
            this._resultBoardService.updateReqCount(this.user_id, this.pRCounter);
          }
        }
      }
    });
  }

  acceptInvitation(item) {
    let dialogRefPreview = this.dialog.open(GamepreviewpopupComponent, {
      width: '800px',
      data: { league_id : item.league_id},
      autoFocus: false
    });
    
    dialogRefPreview.afterClosed()
      .subscribe(res => {
         if (res) { 
           
         }
      })
  }

  onNotify(val, index, text) {
    if (val === 1000) {
      if (text == 'starts in') {
        this.activeDraft[index]['timer'] = 0;
        this.activeDraft[index]['text'] = 'Running';
      }
      //this.activeDrafts();
    }
  }

  getUserDetails() {
    if (this.currentUser) {
      this.sub_userData = this._appService.userDetail(this.currentUser.id, this.currentUser.token).subscribe((res: any) => {
        if (res && res.status === 'success') {
          this.userInfo = res.entities;
          const isNewVersion = this.userInfo && this.userInfo.isNewVersion ? this.userInfo.isNewVersion : false;
          const isMyTeamsNewVersion = this.userInfo && this.userInfo.isMyTeamsNewVersion ? this.userInfo.isMyTeamsNewVersion : false;
          localStorage.setItem('isNewVersion', isNewVersion);
          localStorage.setItem('isMyTeamsNewVersion', isMyTeamsNewVersion);
          this.props_launch_flag = this.userInfo.props_launch_flag;
          this.userInfo.picture = this._appService.getPicture(this.userInfo.picture, 'users', this.userInfo.id);
          this.store.dispatch(new AuthUserData(
            this.userInfo
          ));
          this.store.dispatch(new UserBalanceData(
            this.userInfo.dollar_balance
          ));
        }
      });
    }
  }


  newMessagePopup() {
    this.addMessageDialogRef = this.dialog.open(AddMessageComponent, {
      width: '400px',
      data: {}
    });

    this.addMessageDialogRef.afterClosed().pipe().subscribe(res => {
      if (res === 1) {
      }
    });
  }

  userMessagePage(drafters_id) {
    window.location.href = this.siteURL + '/messages/' + drafters_id;
  }
  
  unescapeMessage(msg) {
    msg = (msg.length > 50) ? msg.substr(0, 50) + '...' : msg;
    return msg.replace(/\\u[\dA-F]{4}/gi, function(match) {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    }).replace(/\\/g, '');
  }

  ngOnDestroy() {
    if (this.subActiveDraft) { this.subActiveDraft.unsubscribe(); }
    if (this.sub_active_draft_data) { this.sub_active_draft_data.unsubscribe(); }
    if (this.subactivePickChanges) { this.subactivePickChanges.unsubscribe(); }
    if (this.subChangeInCurrentDraft) { this.subChangeInCurrentDraft.unsubscribe(); }
    if (this.sub_pick_changes) { this.sub_pick_changes.unsubscribe(); }
    if (this.subrestart_msg) { this.subrestart_msg.unsubscribe(); }
    if (this.subNotificationsReq) { this.subNotificationsReq.unsubscribe(); }
    if (this.subNotificationsData) { this.subNotificationsData.unsubscribe(); }
    if (this.sub_displayMessages) { this.sub_displayMessages.unsubscribe(); }
    if (this.sub_receiveMessage) { this.sub_receiveMessage.unsubscribe(); }
    if (this.sub_userData) { this.sub_userData.unsubscribe(); }
    if (this.sub_league_draft) { this.sub_league_draft.unsubscribe(); }
    if(this.sub_balanceData) { this.sub_balanceData.unsubscribe(); }
  }

  openFAQ() {
    this.dialog.closeAll();
    this.dialog.open(FaqComponent, {
      width: '75%',
      height: '90%'
    });
  }
  
  unescapeString(text) {
    return text.replace(/\\u[\dA-F]{4}/gi, function(match) {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    }).replace(/\\/g, '');
  }
}
